import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { clx } from 'Utils';
import { FontAwesome, SearchFilterLoading } from 'Elements';
import styles from 'partials/feature/search/search-filter-box.module.scss';

interface Props extends PropsWithChildren {
	isLoading?: boolean;
	className?: string;
	onReset?: (() => void) | false;
}

export const SearchFilterBox: FC<Props> = ({
	className,
	children,
	isLoading,
	onReset
}) => {
	const { t } = useTranslation();
	return (
		<aside
			className={clx(
				styles.box,
				'd-inline-block w-100 position-relative',
				className
			)}>
			<header
				className={clx(
					styles.header,
					'd-none d-lg-flex align-items-center mb-3'
				)}>
				<div className="d-flex align-items-center flex-grow-1 text-black gap-2 ">
					<FontAwesome icon="filter" size="lg" swapOpacity />
					<h5 className="fs-6 mb-0 lh-base fw-bold">
						{t('title.filters')}
					</h5>
				</div>
				{onReset && (
					<span
						role="button"
						className="fs-small py-1 text-red d-flex align-items-center gap-2"
						onClick={onReset}>
						<FontAwesome icon="xmark" size="sm" swapOpacity />
						{t('button.reset-filters')}
					</span>
				)}
			</header>
			{isLoading && <SearchFilterLoading count={4} />}
			{!isLoading && children}
		</aside>
	);
};

SearchFilterBox.displayName = 'SearchFilterBox';
